export default "__VITE_ASSET__C1b1bJSp__"